if (!customElements.get('lookbook-section')) {
    customElements.define(
      'lookbook-section',
      class Lookbook extends HTMLElement {
        constructor() {
          super();
  
          var selectors = {
            "lookbook_nummber" : "[data-lookbook-number]"
          }
          
          // L'element qui doit etre en view pour afficher 
          this.numbers = document.querySelectorAll(selectors.lookbook_nummber);
          if (!this.numbers || this.numbers.length == 0) return;
          
          this.toggleItem(this.numbers);
        }
  
        toggleItem(elem) {
            document.querySelector('[data-lookbook-number]:first-child').classList.add('active');
            document.querySelector('[data-lookbook-text]:first-child').classList.add('active');
            for (var i = 0; i < elem.length; i++) {
                elem[i].addEventListener("click", function() {
                    var currentNumber = this;
                    var currentText = document.querySelectorAll('[data-lookbook-text]');
                    for (var i = 0; i < elem.length; i++) {
                        if (currentNumber != elem[i]) {
                            elem[i].classList.remove('active');
                            currentText[i].classList.remove('active');
                        } else {
                            elem[i].classList.add('active');
                            currentText[i].classList.add('active');
                        }
                    }
                });
            };
        }
      },
    );
  }